import {FlyerFrameSettingDto} from "../dtos";

export const findOwnPropertiesForSelectedFrames = (framesData: any): FlyerFrameSettingDto => {
    let frameStateObject: FlyerFrameSettingDto = {
        fpsJumpToPageId: 1,
        fpsLandingPageUrl: null,
        fpsFrameLink: null,
        fpsFrameType: 1,
        fpsIconXPct: 50,
        fpsIconYPct: 50,
        fpsTocEntry: {
            accountId: null,
            caption: null,
            id: null,
            level: null,
            orderInParent: null,
            parentTocEntryId: null,
        },
        fpsTooltip: null,
        fpsFrameLinkApp: null,
        qualificationLevel: null,
        hasNumber: false
    }
    let defaultFrameStateObject: FlyerFrameSettingDto = {
        fpsJumpToPageId: 1,
        fpsLandingPageUrl: null,
        fpsFrameLink: null,
        fpsFrameType: 1,
        fpsIconXPct: 0,
        fpsIconYPct: 0,
        fpsTocEntry: {
            accountId: null,
            caption: null,
            id: null,
            level: null,
            orderInParent: null,
            parentTocEntryId: null,
        },
        fpsTooltip: null,
        fpsFrameLinkApp: null,
        qualificationLevel: null,
        hasNumber: false
    }
    framesData.forEach((frameData: any, index: number) => {
        const keysFrameData = Object.keys(frameStateObject);
        for (let key of keysFrameData) {
            if (index === 0) {
                frameStateObject[key] = frameData[key];
            } else {
                if (JSON.stringify(frameData[key]) !== JSON.stringify(frameStateObject[key])) {
                    frameStateObject[key] = defaultFrameStateObject[key];
                }
            }
        }
    })
    return frameStateObject;
}